import { useEffect, useState } from 'react';
import * as Yup from 'yup';
// form
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { Link, Stack, Alert,
     Typography, Button, IconButton, Grid, CircularProgress
    }from '@mui/material';
import { LoadingButton } from '@mui/lab';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

import FormProvider, { RHFTextField } from '../../../components/hook-form';
import { useAuthContext } from '../../../auth/useAuthContext';

export default function MFAEnrollPhoneForm(params){
    const {setCode, setStage, phone, enrollMFA} = params;
    const [loading, setLoading] = useState("loading");
    const defaultValues = {
        code: '',
    };
    const VerifyCodeSchema = Yup.object().shape({
        code: Yup.string().required('The Code is required'),
      });
    
    const methods = useForm({
        resolver: yupResolver(VerifyCodeSchema),
        defaultValues,
    });
    
    const {
        reset,
        setError,
        handleSubmit,
        formState: { errors, isSubmitting, isSubmitSuccessful },
    } = methods;

    const onSubmit = async(data) => {
        console.log(data);
        enrollMFA(data.code);
    }

    const goBack = ()=>{
        setStage("stage1");
    }

    return (
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>

            <IconButton  sx={{ml:-8, mt: -5, mb:2}} aria-label="back" onClick={goBack}>
                <ArrowBackIosNewIcon/>
            </IconButton>
            <Grid container>
                
                <Grid item xs={12}> 
                    <Stack spacing={2} sx={{ mb: 5, position: 'relative' }}>
                        <Typography variant="h4">
                            Enter the six-digit code sent to {phone}.
                        </Typography>
                        <Typography variant="subtitle1">
                            You will be logged out afterwards and need to log in again.
                        </Typography>
                    
                    </Stack>
                    <Stack sx={{mb:2}}>
                        <RHFTextField name="code" label="Code" />
                    </Stack>
                    <LoadingButton
                    fullWidth
                    color="inherit"
                    size="large"
                    type="submit"
                    variant="contained"
                    loading={isSubmitSuccessful || isSubmitting}
                    sx={{
                    bgcolor: 'text.primary',
                    color: (theme) => (theme.palette.mode === 'light' ? 'common.white' : 'grey.800'),
                    '&:hover': {
                        bgcolor: 'text.primary',
                        color: (theme) => (theme.palette.mode === 'light' ? 'common.white' : 'grey.800'),
                    },
                    }}
                    >
                        Submit
                    </LoadingButton>
                </Grid>
            </Grid>

        </FormProvider >
    )
}